import axios from 'axios';
import { apiUrl, menuUrl } from '../env';
import { getAuthHeaders } from './utils';
import store from '../store';
import { TTFormSubmission, TTFormSubmissionCreate } from '../interfaces/forms';
/* eslint-disable */
export const formsApi = {
  async addFormEntry(body: TTFormSubmissionCreate) {
    return axios.post<TTFormSubmission>(
      `${menuUrl}/api/v1/form-submissions/`,
      body,
      {
        headers: await getAuthHeaders(),
      },
    );
  },
};
